import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { TwitterSocialShareStep } from '../../types';
import TwitterPostComposerStep from './TwitterPostComposerStep';

export type UseTwitterPostComposerStepConfig = {
  onShare: () => void;
};

export default function useTwitterPostComposerStep({
  onShare,
}: UseTwitterPostComposerStepConfig): Step<TwitterSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: <TwitterPostComposerStep />,
  };
}
